<template>
	<div class="main-content">
		<div class="center-body">
			<Nav />
		
<!-- 第一层（替换后的“专注行业解决方案”板块） -->
<!-- 替换原“第一层（替换后的‘专注行业解决方案’板块）”为以下内容 -->
<div class="row" style="position: relative; padding: 120px 0 80px; background: #f8faff; overflow: hidden; flex-direction: column; align-items: center;">
  <div style="max-width: 1200px; width: 100%; margin: 0 auto; padding: 0 24px; box-sizing: border-box; display: flex; align-items: center; justify-content: space-between;">
    <!-- 左侧文字区域 -->
    <div style="width: 50%; padding-right: 40px;">
      <!-- 标题（带蓝色边框） -->
      <div style="font-size: 28px; font-weight: bold; color: #333; line-height: 1.4; margin-bottom: 20px; padding-left: 5px;">
        精准“透视”水务系统，让每<br>
        一滴水创造更大价值。
      </div>
      <!-- 描述文本 -->
      <div style="font-size: 14px; color: #666; line-height: 22px; margin-bottom: 30px;">
        基于AI大数据模型，实现对供水全流程的精准监控与智能调度。有效降低管网漏损、优化能耗、保障水质安全，驱动水务企业实现精细化管理和效益提升。
      </div>
      <!-- 预约演示按钮 -->
      <button style="padding: 10px 20px; background: #0e0e0e; color: #fff; border: none; border-radius: 4px; cursor: pointer; font-size: 14px;">
        预约演示
      </button>
      <!-- 功能标签区域（横向五栏：白圆灰边 + 黑色公文包图标） -->

    </div>
    <!-- 右侧图表占位区域 -->
    <div style="width: 45%; background: #fff; border-radius: 8px; padding: 20px; box-shadow: 0 4px 12px rgba(0,0,0,0.05);">
      <!-- 这里替换为实际图表（比如ECharts），先占位 -->
      <div style="width: 100%; height: 250px; background: #f9f9f9; border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #ccc;">
        <img src="../../assets/img/zlindex9.png" style="width: 130%; border-radius: 8px; object-fit: cover;" />
      </div>
    </div>
  </div>

  <div class="apps-wrap">
  <div class="apps apps-bar">
    <div class="apps-item">
      <span class="apps-icon-wrap" aria-hidden="true">
        <svg class="apps-briefcase" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
          <path d="M20 6h-2V4c0-1.11-.89-2-2-2H8c-1.11 0-2 .89-2 2v2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-4 0H8V4h8v2z" />
        </svg>
      </span>
      <span class="apps-label">水务营收</span>
    </div>
    <div class="apps-item">
      <span class="apps-icon-wrap" aria-hidden="true">
        <svg class="apps-briefcase" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
          <path d="M20 6h-2V4c0-1.11-.89-2-2-2H8c-1.11 0-2 .89-2 2v2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-4 0H8V4h8v2z" />
        </svg>
      </span>
      <span class="apps-label">物联网采集</span>
    </div>
    <div class="apps-item">
      <span class="apps-icon-wrap" aria-hidden="true">
        <svg class="apps-briefcase" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
          <path d="M20 6h-2V4c0-1.11-.89-2-2-2H8c-1.11 0-2 .89-2 2v2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-4 0H8V4h8v2z" />
        </svg>
      </span>
      <span class="apps-label">DMA漏损</span>
    </div>
    <div class="apps-item">
      <span class="apps-icon-wrap" aria-hidden="true">
        <svg class="apps-briefcase" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
          <path d="M20 6h-2V4c0-1.11-.89-2-2-2H8c-1.11 0-2 .89-2 2v2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-4 0H8V4h8v2z" />
        </svg>
      </span>
      <span class="apps-label">水务调度</span>
    </div>
    <div class="apps-item">
      <span class="apps-icon-wrap" aria-hidden="true">
        <svg class="apps-briefcase" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
          <path d="M20 6h-2V4c0-1.11-.89-2-2-2H8c-1.11 0-2 .89-2 2v2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-4 0H8V4h8v2z" />
        </svg>
      </span>
      <span class="apps-label">GIS管网巡检</span>
    </div>
  </div>
  </div>
</div>

<!-- 第二层（城市燃气安全防护网板块） -->
<div style="margin: 80px auto; min-height: 300px; width: 1200px; padding: 40px; background: #f8faff; border-radius: 8px; box-shadow: 0 2px 12px rgba(0,0,0,0.05);">
  <!-- 标题区域 -->
  <div style="color: #000; font-size: 24px; font-weight: bold; text-align: center; margin-bottom: 40px;">
    实现产销协同丶精准降耗的智慧供水调度体系。
  </div>

  <!-- 系统卡片区域（3列3行布局） -->
  <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 30px; justify-items: center;">
    <!-- 第一行 -->
    <div style="display: flex; flex-direction: column; align-items: center; gap: 10px; padding: 20px; text-align: center;">
      <div class="sys-card-icon" title="水务营收系统">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill="currentColor" d="M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/></svg>
      </div>
      <div style="font-size: 16px; color: #333; font-weight: 500;">水务营收系统</div>
    </div>
    <div style="display: flex; flex-direction: column; align-items: center; gap: 10px; padding: 20px; text-align: center;">
      <div class="sys-card-icon" title="物联网采集系统">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill="currentColor" d="M12 18c.83 0 1.5-.67 1.5-1.5S12.83 15 12 15s-1.5.67-1.5 1.5S11.17 18 12 18zm-7.29-2.29L4.83 16.4C3.26 14.82 2.45 12.93 2.45 11c0-1.93.81-3.82 2.38-5.38l.88.88C4.02 8.21 3.35 9.59 3.35 11c0 1.41.67 2.79 1.86 3.96l-.88.75zm14.58 0l-.88-.75C18.98 13.79 19.65 12.41 19.65 11c0-1.41-.67-2.79-1.86-3.96l.88-.88C19.74 7.16 20.55 9.05 20.55 11c0 1.93-.81 3.82-2.38 5.38zM12 6.5c1.93 0 3.5 1.57 3.5 3.5S13.93 13.5 12 13.5 8.5 11.93 8.5 10s1.57-3.5 3.5-3.5z"/></svg>
      </div>
      <div style="font-size: 16px; color: #333; font-weight: 500;">物联网采集系统</div>
    </div>
    <div style="display: flex; flex-direction: column; align-items: center; gap: 10px; padding: 20px; text-align: center;">
      <div class="sys-card-icon" title="DMA漏损系统">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill="currentColor" d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0L12 2.69zm-1 12.31h2v3h-2v-3zm0-6h2v4h-2v-4z"/></svg>
      </div>
      <div style="font-size: 16px; color: #333; font-weight: 500;">DMA漏损系统</div>
    </div>

    <!-- 第二行 -->
    <div style="display: flex; flex-direction: column; align-items: center; gap: 10px; padding: 20px; text-align: center;">
      <div class="sys-card-icon" title="一体化智慧调度系统">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill="currentColor" d="M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V7H7v2zm14 4v-2H11v2h10zm-6-4h2V7h-2v2z"/></svg>
      </div>
      <div style="font-size: 16px; color: #333; font-weight: 500;">一体化智慧调度系统</div>
    </div>
    <div style="display: flex; flex-direction: column; align-items: center; gap: 10px; padding: 20px; text-align: center;">
      <div class="sys-card-icon" title="GIS管网巡检系统">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill="currentColor" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>
      </div>
      <div style="font-size: 16px; color: #333; font-weight: 500;">GIS管网巡检系统</div>
    </div>
    <div style="display: flex; flex-direction: column; align-items: center; gap: 10px; padding: 20px; text-align: center;">
      <div class="sys-card-icon" title="综合分析决策平台">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"/></svg>
      </div>
      <div style="font-size: 16px; color: #333; font-weight: 500;">综合分析决策平台</div>
    </div>

    <!-- 第三行 -->
    <div style="display: flex; flex-direction: column; align-items: center; gap: 10px; padding: 20px; text-align: center;">
      <div class="sys-card-icon" title="智慧供水管理系统">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill="currentColor" d="M12 2c-5.33 4.55-8 8.03-8 11 0 3.31 2.69 6 6 6s6-2.69 6-6c0-2.97-2.67-6.45-8-11zm-1 17.93c-2.83-.48-5-3-5-6.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/></svg>
      </div>
      <div style="font-size: 16px; color: #333; font-weight: 500;">智慧供水管理系统</div>
    </div>
    <div style="display: flex; flex-direction: column; align-items: center; gap: 10px; padding: 20px; text-align: center;">
      <div class="sys-card-icon" title="综合分析决策平台">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"/></svg>
      </div>
      <div style="font-size: 16px; color: #333; font-weight: 500;">综合分析决策平台</div>
    </div>
    <div style="display: flex; flex-direction: column; align-items: center; gap: 10px; padding: 20px; text-align: center;">
      <div class="sys-card-icon" title="移动缴费(掌上营业厅)">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill="currentColor" d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"/></svg>
      </div>
      <div style="font-size: 16px; color: #333; font-weight: 500;">移动缴费(掌上营业厅)</div>
    </div>
  </div>
</div>
<!-- 第三层（市场洞察：综合营收+物联网采集系统板块） -->
 <div style="background: linear-gradient(338deg, rgb(238, 238, 255), transparent);padding-top: 20px;padding-bottom: 20px;">
  <div style="margin: 80px auto; min-height: 400px; width: 1200px; padding: 40px; border-radius: 8px;background:">
    <!-- 顶部标题 -->
    <div style="font-size: 18px; color: #409eff; font-weight: 500; margin-bottom: 10px;">市场洞察</div>
  
    <!-- 内容分栏（上下两部分） -->
    <div style="display: flex; flex-direction: column; gap: 60px;">
      <!-- 第一部分：综合营收系统 -->
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <!-- 左侧文字区域 -->
        <div style="width: 45%;">
          <div style="font-size: 22px; font-weight: bold; color: #333; margin-bottom: 20px;">综合营收系统</div>
          <div style="font-size: 14px; color: #666; line-height: 22px;">
            <p style="margin-top: 10px;line-height: 18px;">普表、物联网表二合一缴费</p>
            <p style="margin-top: 10px;line-height: 18px;">统一价格编码及定价调价管理；</p>
            <p style="margin-top: 10px;line-height: 18px;">阶梯及统一价格计费；</p>
            <p style="margin-top: 10px;line-height: 18px;">丰富的客户、表具、账务等相关报表统计功能；</p>
            <p style="margin-top: 10px;line-height: 18px;">支持退费、退款。移动端缴费支持费用原路返回；</p>
            <p style="margin-top: 10px;line-height: 18px;">基础业务办理，过户、销户、报停、账单审核等；</p>
          </div>
        </div>
        <!-- 右侧图表占位 -->
        <div style="width: 45%; display: flex; flex-direction: column; gap: 20px; align-items: flex-end;">
          <div style="width: 100%; height: 80px; border-radius: 4px; display: flex; justify-content: center; align-items: center;">
             <img src="../../assets/img/zlindex17.png" style="width: 100%; border-radius: 8px; object-fit: cover;" />
          </div>
          <!-- <div style="width: 80%; height: 120px; background: #f9f9f9; border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #ccc;">
           <img src="../../assets/img/cpzxBanner.png" style="width: 100%; border-radius: 8px; object-fit: cover;" />
          </div> -->
          <!-- <div style="width: 60%; height: 40px; background: #e1f5ff; border-radius: 4px;"></div> -->
        </div>
      </div>
  
      <!-- 第二部分：物联网采集系统 -->
      <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 100px;">
        <!-- 左侧图表占位 -->
        <div style="width: 45%; display: flex; flex-direction: column; gap: 20px;">
          <!-- <div style="width: 60%; height: 40px; background: #409eff; border-radius: 4px;"></div> -->
          <div style="width: 100%; height: 120px;border-radius: 4px; display: flex; justify-content: center; align-items: center; ">
             <img src="../../assets/img/zlindex18.png" style="width: 100%; border-radius: 8px; object-fit: cover;" />
          </div>
          <!-- <div style="width: 80%; height: 40px; background: #e1f5ff; border-radius: 4px; align-self: flex-end;"></div> -->
        </div>
        <!-- 右侧文字区域 -->
        <div style="width: 45%;">
          <!-- <div style="font-size: 18px; color: #409eff; font-weight: 500; margin-bottom: 5px;">时间追踪器</div> -->
          <div style="font-size: 22px; font-weight: bold; color: #333; margin-bottom: 20px;">物联网采集系统</div>
          <div style="font-size: 14px; color: #666; line-height: 22px;">
             <!-- <p style="margin-top: 10px; font-size: 20px; ">强强合作</p> -->
             <p style="margin-top: 10px; font-weight: 700; color: #333;">强强合作</p>
            <p style="margin-top: 10px;line-height: 18px;">与电信V移动华为腾讯VONENET等通讯平台建立强强合作·多方式抄表及远程数据采</p>
               <p style="margin-top: 10px; font-weight: 700; color: #333;">快速兼容</p>
             <p style="margin-top: 10px;line-height: 18px;">快速兼容不同厂家、不同协议表型，实现一个平台统一管理无缝对接</p>
            <p style="margin-top: 10px;line-height: 18px;">通过与智能综合抄表平台无缝对接，自动获取每天或指定日期的抄表数据，确保和营收系统数据同步,达到收要无误的目的。</p>
  
            <p style="margin-top: 10px;line-height: 18px;">由上海市计算机软件评测重点实验室(上海计算机软件技术开发中心)进行性能测试，实现了《物联网表数据采集平台性能指标》中相关性能指标要求，响应速度达到毫秒级。</p>
      </div>
        </div>
      </div>
    </div>
  </div>
 </div>


<!-- 第四层（管网资产：GIS管网监控+巡检系统板块） -->
<div style="padding-top: 120px;">
  <div style="margin: 80px auto; min-height: 500px; width: 1200px; padding: 40px;">
    <!-- 顶部标题 -->
    <div style="font-size: 18px; color: #409eff; font-weight: 500; margin-bottom: 10px;">管网资产</div>
  
    <!-- 内容分栏（上下两部分） -->
    <div style="display: flex; flex-direction: column; gap: 60px;">
      <!-- 第一部分：GIS管网监控系统 -->
      <div style="display: flex; justify-content: space-between; align-items: flex-start;">
        <!-- 左侧文字+功能点区域 -->
        <div style="width: 45%;">
          <div style="font-size: 22px; font-weight: bold; color: #333; margin-bottom: 20px;">GIS管网监控系统</div>
          <div style="font-size: 14px; color: #666; line-height: 22px; margin-bottom: 20px;">
            管理和分析城市供水管网、排水管网等基础实施的数据，通过数字化建模实现空间数据的可视化展示与动态管理，为水司提供决策支持、运营优化和应急响应等全方位服务。
          </div>
          <!-- 功能点列表（带图标） -->
          <div style="display: flex; flex-direction: column; gap: 15px;">
            <div style="display: flex; align-items: flex-start; gap: 10px;">
              <div style="width: 24px; height: 24px; background: #e1f5ff; border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #409eff; font-size: 14px; flex-shrink: 0; margin-top: 2px;">📊</div>
              <div>
                <div style="font-weight: 500; color: #333;">数据管理与可视化</div>
                <div style="font-size: 13px; color: #666;line-height: 18px;">整合各管网相关专业数据和地理信息，包括管网位置、管网材质、在地图上直观展示，方便管理人员清晰掌握管网信息。</div>
              </div>
            </div>
            <div style="display: flex; align-items: flex-start; gap: 10px;">
              <div style="width: 24px; height: 24px; background: #e1f5ff; border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #409eff; font-size: 14px; flex-shrink: 0; margin-top: 2px;">📡</div>
              <div>
                <div style="font-weight: 500; color: #333;">设备实时监控</div>
                <div style="font-size: 13px; color: #666;line-height: 18px;">与传感器对接，实时获取管网压力、流量、水质等数据，及时发现异常变化，如漏水、水质超标等问题。</div>
              </div>
            </div>
            <div style="display: flex; align-items: flex-start; gap: 10px;">
              <div style="width: 24px; height: 24px; background: #e1f5ff; border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #409eff; font-size: 14px; flex-shrink: 0; margin-top: 2px;">⚠️</div>
              <div>
                <div style="font-weight: 500; color: #333;">故障分析与预警</div>
                <div style="font-size: 13px; color: #666;line-height: 18px;">故障发生时精准定位，分析可能造成的影响范围，辅助快速出警、维修制定应急计划，减少损失。</div>
              </div>
            </div>
            <div style="display: flex; align-items: flex-start; gap: 10px;">
              <div style="width: 24px; height: 24px; background: #e1f5ff; border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #409eff; font-size: 14px; flex-shrink: 0; margin-top: 2px;">🚨</div>
              <div>
                <div style="font-weight: 500; color: #333;">应急处置</div>
                <div style="font-size: 13px; color: #666;line-height: 18px;">在突发事件（如爆管）时，快速定位位置，提供周边环境信息及救援信息，辅助应急抢险人员快速有效处置，提高应急处理效率。</div>
              </div>
            </div>
          </div>
        </div>
              <div style="width: 45%; display: flex; flex-direction: column; gap: 20px; align-items: flex-end;">
          <div style="width: 100%; height: 80px; background: #f9f9f9; border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #ccc;">
             <img src="../../assets/img/zlindex12.png" style="width: 100%; border-radius: 8px; object-fit: cover;" />
          </div>
          <!-- <div style="width: 80%; height: 120px; background: #f9f9f9; border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #ccc;">
           <img src="../../assets/img/cpzxBanner.png" style="width: 100%; border-radius: 8px; object-fit: cover;" />
          </div> -->
          <!-- <div style="width: 60%; height: 40px; background: #e1f5ff; border-radius: 4px;"></div> -->
        </div>
      </div>
        <!-- 右侧图表占位 -->
        <!-- <div style="width: 45%; display: flex; flex-direction: column; gap: 20px; align-items: flex-end;">
          <div style="width: 80%; height: 40px; background: #e1f5ff; border-radius: 4px; display: flex; align-items: center; padding: 0 10px;">
            <span style="width: 16px; height: 16px; background: #409eff; border-radius: 50%; margin-right: 8px;"></span>
            <div style="height: 60%; background: #ddd; flex: 1; border-radius: 2px;"></div>
          </div>
          <div style="width: 100%; display: flex; gap: 20px; align-items: center;">
            <div style="width: 80px; height: 80px; background: #f9f9f9; border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #ccc;">
              <img src="../../assets/img/cpzxBanner.png" style="width: 100%; border-radius: 4px; object-fit: cover;" />
            </div>
            <div style="width: 120px; height: 120px; background: #f9f9f9; border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #ccc;">
              <img src="../../assets/img/cpzxBanner.png" style="width: 100%; border-radius: 4px; object-fit: cover;" />
            </div>
          </div>
        </div> -->
  
      <!-- 第二部分：GIS管网巡检系统 -->
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <!-- 左侧图表占位 -->
        <div style="width: 45%; display: flex; flex-direction: column; gap: 20px;">
          <!-- <div style="width: 60%; height: 40px; background: #409eff; border-radius: 4px;"></div> -->
          <div style="width: 100%; height: 180px; background: #f9f9f9; border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #ccc;">
            <img src="../../assets/img/zlindex13.png" style="width: 100%; border-radius: 4px; object-fit: cover;" />
          </div>
          <!-- <div style="width: 80%; height: 40px; background: #e1f5ff; border-radius: 4px; align-self: flex-end;"></div> -->
        </div>
        <!-- 右侧文字+功能点区域 -->
        <div style="width: 45%;">
          <div style="font-size: 18px; color: #409eff; font-weight: 500; margin-bottom: 5px;">隐患排查</div>
          <div style="font-size: 22px; font-weight: bold; color: #333; margin-bottom: 20px;">GIS管网巡检系统</div>
          <div style="font-size: 14px; color: #666; line-height: 22px; margin-bottom: 20px;">
            监管者GIS管网及巡检人员的工作行为，相关上报GIS管网现存隐患，通过信息化的手段对GIS管网及设备运行等信息采集，并跟踪处理工艺上制定定位功能实现突发事件的定位及指引。
          </div>
          <!-- 功能点列表（带图标） -->
          <div style="display: flex; flex-direction: column; gap: 15px;">
            <div style="display: flex; align-items: flex-start; gap: 10px;">
              <div style="width: 24px; height: 24px; background: #e1f5ff; border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #409eff; font-size: 14px; flex-shrink: 0; margin-top: 2px;">📅</div>
              <div>
                <div style="font-weight: 500; color: #333;">计划制定</div>
                <div style="font-size: 13px; color: #666; line-height: 18px;">管理者可以通过系统制定任务平台，计划制定人员。</div>
              </div>
            </div>
            <div style="display: flex; align-items: flex-start; gap: 10px;">
              <div style="width: 24px; height: 24px; background: #e1f5ff; border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #409eff; font-size: 14px; flex-shrink: 0; margin-top: 2px;">📱</div>
              <div>
                <div style="font-weight: 500; color: #333;">任务执行</div>
                <div style="font-size: 13px; color: #666; line-height: 18px;">管理人员通过手机App实时接收任务，现场人员，现场签到。</div>
              </div>
            </div>
            <div style="display: flex; align-items: flex-start; gap: 10px;">
              <div style="width: 24px; height: 24px; background: #e1f5ff; border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #409eff; font-size: 14px; flex-shrink: 0; margin-top: 2px;">🔧</div>
              <div>
                <div style="font-weight: 500; color: #333;">隐患上报</div>
                <div style="font-size: 13px; color: #666; line-height: 18px;">管理人员现场拍照、记录问题，推送给处理人员，跟踪处理要求、完成时效等。</div>
              </div>
            </div>
            <div style="display: flex; align-items: flex-start; gap: 10px;">
              <div style="width: 24px; height: 24px; background: #e1f5ff; border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #409eff; font-size: 14px; flex-shrink: 0; margin-top: 2px;">📊</div>
              <div>
                <div style="font-weight: 500; color: #333;">隐患统计分析</div>
                <div style="font-size: 13px; color: #666; line-height: 18px;">管理人员可以对隐患统计、分析、部门统计、人员统计等，为管理提供辅助决策。</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div style="background: linear-gradient(86deg, rgba(193, 228, 253, 0.46), transparent);padding-top: 40px;padding-bottom: 40px;">
  <!-- 第五层（DMA漏损+水务调度+综合分析决策板块） -->
<div style="margin: 80px auto; min-height: 600px; width: 1200px; padding: 40px; ">
  <!-- 第一部分：DMA漏损平台 -->
  <div style="margin-bottom: 60px;">
    <div style="font-size: 18px; color: #409eff; font-weight: 500; margin-bottom: 10px;">预控监管</div>
    <div style="display: flex; justify-content: space-between; align-items: flex-start; gap: 40px;">
      <!-- 左侧文字+功能卡片 -->
      <div style="width: 45%;">
        <div style="font-size: 22px; font-weight: bold; color: #333; margin-bottom: 20px;">DMA漏损平台</div>
        <div style="font-size: 14px; color: #666; line-height: 22px; margin-bottom: 20px;">
          基于智慧化漏损管控经验，结合分区计量(DMA)技术和水力模型，通过对区域流量监测、压力调控等手段，实现对供水管网漏损的精准定位和有效控制，从而达到降低漏损率、减少水资源浪费和提高供水效率的目的。
        </div>
        <!-- 蓝色功能卡片 -->
        <div style=" border-radius: 8px; padding: 15px 0px; font-size: 13px; line-height: 20px;">
          <div style="font-weight: 500; margin-bottom: 8px;">分区计量与监控</div>
          <div style="line-height: 18px;">将供水管网划分成若干个独立的计量区域(DMA)，每个区域安装流量计、压力计等监测设备，实时监测各区域的流量、压力等数据。</div>
          <div style="font-weight: 500; margin: 8px 0;">漏损分析与定位</div>
          <div style="line-height: 18px;">通过对各DMA区域的流量、压力数据进行分析，结合夜间最小流量法、压力调控等技术，识别出可能存在漏损的区域，并进行精准定位。</div>
          <div style="font-weight: 500; margin: 8px 0;">压力调控与优化</div>
          <div style="line-height: 18px;">根据管网的实际情况和漏损情况，对管网压力进行合理调控，在保证供水服务质量的前提下，降低管网压力，减少漏损的发生。</div>
        </div>
      </div>
      <!-- 右侧图表占位 -->
      <!-- <div style="width: 45%; display: flex; flex-direction: column; gap: 20px; align-items: flex-end;">
        <div style="width: 80%; height: 40px; background: #e1f5ff; border-radius: 4px; display: flex; align-items: center; padding: 0 10px;">
          <span style="width: 16px; height: 16px; background: #409eff; border-radius: 50%; margin-right: 8px;"></span>
          <div style="height: 60%; background: #ddd; flex: 1; border-radius: 2px;"></div>
        </div>
        <div style="width: 100%; display: flex; gap: 20px; align-items: center;">
          <div style="width: 80px; height: 80px; background: #f9f9f9; border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #ccc;">
            <img src="../../assets/img/gywmBanner.png" style="width: 100%; border-radius: 4px; object-fit: cover;" />
          </div>
          <div style="width: 120px; height: 120px; background: #f9f9f9; border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #ccc;">
            <img src="../../assets/img/gywmBanner.png" style="width: 100%; border-radius: 4px; object-fit: cover;" />
          </div>
        </div>
      </div> -->
    
             <div style="width: 45%; display: flex; flex-direction: column; gap: 20px; align-items: flex-end;">
        <div style="width: 100%;  border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #ccc;">
           <img src="../../assets/img/zlindex19.png" style="width: 80%; border-radius: 8px; object-fit: cover;" />
        </div>
        <!-- <div style="width: 80%; height: 120px; background: #f9f9f9; border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #ccc;">
         <img src="../../assets/img/cpzxBanner.png" style="width: 100%; border-radius: 8px; object-fit: cover;" />
        </div> -->
        <!-- <div style="width: 60%; height: 40px; background: #e1f5ff; border-radius: 4px;"></div> -->
      </div>
    </div>
  </div>

  <!-- 第二部分：智慧水务调度系统 -->
  <div style="margin-bottom: 60px;">
    <div style="display: flex; justify-content: space-between; align-items: center; gap: 40px;">
      <!-- 左侧图表占位 -->
      <div style="width: 45%; display: flex; flex-direction: column; gap: 20px;">
        <!-- <div style="width: 60%; height: 40px; background: #409eff; border-radius: 4px;"></div> -->
        <div style="width: 100%; height: 180px;  border-radius: 4px; display: flex; justify-content: center; align-items: center; ">
          <img src="../../assets/img/zlindex20.png" style="width: 100%; border-radius: 4px; object-fit: cover;" />
        </div>
        <!-- <div style="width: 80%; height: 40px; background: #e1f5ff; border-radius: 4px; align-self: flex-end;"></div> -->
      </div>
      <!-- 右侧文字区域 -->
      <div style="width: 45%;">
        <div style="font-size: 18px; color: #409eff; font-weight: 500; margin-bottom: 5px;">精益管理</div>
        <div style="font-size: 22px; font-weight: bold; color: #333; margin-bottom: 20px;">智慧水务调度系统</div>
        <div style="font-size: 14px; color: #666; line-height: 22px;">
          水务调度是水厂、水司、水务管理部门的核心管理环节之一，建立以水质安全为中心，整合水源地信息、水厂信息、二供泵房等信息的综合调度平台，为水务决策提供数据支撑与科学指导。
          <div style="margin-top: 10px; font-weight: 600; color: #333;">调度中心</div>
          <div style="margin-top: 5px;line-height: 18px;">全面掌握水厂、泵站、管网、水质、能耗等信息，实现对水源、管网、设备等的集中监控，满足从水源输送到用户端的全流程调度管理。</div>
          <div style="margin-top: 10px; font-weight: 600; color: #333;">数据分析</div>
          <div style="margin-top: 5px;line-height: 18px;">实现对供水数据的深度分析，如产量管理、管网压力、水质管理、水量管理等，为调度决策提供数据支持。</div>
          <div style="margin-top: 10px; font-weight: 600; color: #333;">调度预案</div>
          <div style="margin-top: 5px;line-height: 18px;">系统提供多种调度预案，如应急调度、高峰供水调度、水质异常调度等，可根据实际情况快速启动相应预案，提高调度效率。</div>
          <div style="margin-top: 10px; font-weight: 600; color: #333;">工单处理</div>
          <div style="margin-top: 5px;line-height: 18px;">结合工单系统实现调度指令的下发与跟踪，保证指令的有效执行，同时可与巡检、维修等业务流程联动，实现业务的闭环管理。</div>
        </div>
      </div>
    </div>
  </div>

  <!-- 第三部分：综合分析决策平台 -->
  <div>
    <div style="font-size: 18px; color: #409eff; font-weight: 500; margin-bottom: 10px;">五大分析模块</div>
    <div style="display: flex; justify-content: space-between; align-items: flex-start; gap: 40px;">
      <!-- 左侧文字区域 -->
      <div style="width: 45%;">
        <div style="font-size: 22px; font-weight: bold; color: #333; margin-bottom: 20px;">综合分析决策平台</div>
        <div style="font-size: 14px; color: #666; line-height: 22px;">
          <div style="margin-top: 10px; font-weight: 700; color: #333;">资产分析决策：</div>
          <div style="margin-top: 4px;line-height: 18px;">基于GIS实现供水管网全要素可视化管理，整合动静态数据，为管网建模与科学规划奠定基础。</div>
          <div style="margin-top: 10px; font-weight: 700; color: #333;">营销分析决策:</div>
          <div style="margin-top: 4px;line-height: 18px;">深度分析水量、产销差、回收率等核心指标，精准定位运营问题，为营销策略与效益提升提供数据支撑。</div>
          <div style="margin-top: 10px; font-weight: 700; color: #333;">调度分析决策:</div>
          <div style="margin-top: 4px;line-height: 18px;">集成水质、水量、能耗等多维度数据，构建智慧调度中心，实现生产运行优化与成本精细管控。</div>

          <div style="margin-top: 10px; font-weight: 700; color: #333;">综合决策中心::</div>
          <div style="margin-top: 4px;line-height: 18px;">综合分析用户用水、热线服务与设备运行状况，提升服务质量，优化人力资源与运营成本。</div>

          <div style="margin-top: 10px; font-weight: 700; color: #333;">高层辅助决策:</div>
          <div style="margin-top: 4px;line-height: 18px;">智能汇总运营问题，通过投入产出分析与方案比选，为管理层提供科学决策依据，推动智慧化转型。</div>

        </div>
      </div>
      <!-- 右侧图表占位 -->
      <!-- <div style="width: 45%; display: flex; flex-direction: column; gap: 20px; align-items: flex-end;">
        <div style="width: 80%; height: 40px; background: #e1f5ff; border-radius: 4px; display: flex; align-items: center; padding: 0 10px;">
          <span style="width: 16px; height: 16px; background: #409eff; border-radius: 50%; margin-right: 8px;"></span>
          <div style="height: 60%; background: #ddd; flex: 1; border-radius: 2px;"></div>
        </div>
        <div style="width: 100%; display: flex; gap: 20px; align-items: center;">
          <div style="width: 80px; height: 80px; background: #f9f9f9; border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #ccc;">
            <img src="../../assets/img/gywmBanner.png" style="width: 100%; border-radius: 4px; object-fit: cover;" />
          </div>
          <div style="width: 120px; height: 120px; background: #f9f9f9; border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #ccc;">
            <img src="../../assets/img/gywmBanner.png" style="width: 100%; border-radius: 4px; object-fit: cover;" />
          </div>
        </div>
      </div> -->
             <div style="width: 45%; display: flex; flex-direction: column; gap: 20px; align-items: flex-end;">
        <div style="width: 100%; background: #f9f9f9; border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #ccc;">
           <img src="../../assets/img/zlindex21.png" style="width: 100%; border-radius: 8px; object-fit: cover;" />
        </div>
        <!-- <div style="width: 80%; height: 120px; background: #f9f9f9; border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #ccc;">
         <img src="../../assets/img/cpzxBanner.png" style="width: 100%; border-radius: 8px; object-fit: cover;" />
        </div> -->
        <!-- <div style="width: 60%; height: 40px; background: #e1f5ff; border-radius: 4px;"></div> -->
      </div>
    
    </div>
  </div>
</div>
</div>

<div class="product">
	<div class="product-wrap">
		<div class="product-inner">
			<p class="product-kicker">核心优势</p>
			<h2 class="product-headline">产品特点</h2>
			<div class="product-grid">
				<article
					v-for="(item, index) in productFeatures"
					:key="item.title"
					class="product-card"
				>
					<div class="product-icon" aria-hidden="true">
						<!-- 产销差 / DMA 计量与漏损分析 -->
						<svg
							v-if="item.icon === 'dma-analytics'"
							class="product-icon-svg"
							viewBox="0 0 24 24"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path fill="currentColor" d="M4 19h16v1.5H4V19z" />
							<path fill="currentColor" d="M6.5 18V11h3v7h-3zm5 0V8h3v10h-3zm5 0v-5h3v5h-3z" />
							<path fill="currentColor" d="M12 4.5a2.2 2.2 0 1 0 0 4.4 2.2 2.2 0 0 0 0-4.4zm0 1.2a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
							<path fill="currentColor" fill-opacity=".35" d="M10 6.5h4v1h-4v-1z" />
						</svg>
						<!-- 多目标协同调度（多滑轴 / 多指标平衡） -->
						<svg
							v-else-if="item.icon === 'multi-dispatch'"
							class="product-icon-svg"
							viewBox="0 0 24 24"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path fill="none" stroke="currentColor" stroke-width="1.45" stroke-linecap="round" d="M4 7h16M4 12h16M4 17h16" />
							<circle fill="currentColor" cx="14.5" cy="7" r="2.1" />
							<circle fill="currentColor" cx="9.5" cy="12" r="2.1" />
							<circle fill="currentColor" cx="16" cy="17" r="2.1" />
						</svg>
						<!-- 从源头到龙头：水源—管网—用户端 -->
						<svg
							v-else-if="item.icon === 'source-to-tap'"
							class="product-icon-svg"
							viewBox="0 0 24 24"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path fill="currentColor" d="M12 2.8c-1.1 1.5-2.4 3.3-2.4 5.7a2.6 2.6 0 0 0 4.8 0c0-2.4-1.3-4.2-2.4-5.7z" />
							<path fill="none" stroke="currentColor" stroke-width="1.45" stroke-linecap="round" d="M12 9v3.5" />
							<path fill="none" stroke="currentColor" stroke-width="1.35" stroke-linecap="round" d="M7.5 14.5c1.1.9 2.4 1.4 4.5 1.4s3.4-.5 4.5-1.4" />
							<path fill="none" stroke="currentColor" stroke-width="1.35" stroke-linecap="round" d="M9 18h6" />
							<path fill="currentColor" d="M10.8 18h2.4v2a.9.9 0 0 1-1.8 0v-2z" />
							<circle fill="currentColor" cx="7.5" cy="13.2" r="1.05" />
							<circle fill="currentColor" cx="16.5" cy="13.2" r="1.05" />
						</svg>
					</div>
					<h3 class="product-card-title">{{ item.title }}</h3>
					<p class="product-card-text">{{ item.text }}</p>
				</article>
			</div>
		</div>
	</div>
</div>


			<Foot />
		</div>
	</div>
</template>

<script>
	import Nav from "./nav.vue";
	import Foot from "./foot.vue";

	export default {
		name: "App",
		components: {
			Nav,
			Foot
		},
		data() {
			return {
				curHeight: 0,
				index:0,
				productFeatures: [
					{
						icon: "dma-analytics",
						title: "产销差精细化管理",
						text:
							"基于DMA分区计量与漏损分析系统，精准定位并量化管网漏损，结合营收数据，实现从“源头”到“水龙头”的产销差全流程精细管控，有效提升水资源效益。",
					},
					{
						icon: "multi-dispatch",
						title: "多目标协同调度",
						text:
							"融合管网压力、水质、能耗与用水需求数据，构建厂网协同的智能调度体系。在保障稳定供水与水压平衡的同时，显著优化能耗与制水成本，实现安全与效益的双重提升。",
					},
					{
						icon: "source-to-tap",
						title: "从源头到龙头的全流程守护",
						text:
							"通过GIS与监控系统，实现对水源、水厂、管网及用户端水质的全过程监控与溯源管理，结合巡检与营收服务，构建覆盖供水全链条的水质安全与服务体系。",
					},
				],
			};
		},
		watch: {
			windowHeight(val) {
				let that = this;
				console.log("实时屏幕高度：", val, that.windowHeight);
			},
		},
		beforeMount() {

			var h = document.documentElement.clientHeight || document.body.clientHeight;

			this.curHeight = h; //减去页面上固定高度height

		},
		methods: {
			enter(e){
				this.index=e
			},
			leave(){
				this.index=0
			}
		},
		mounted() {
			var that = this;
			window.onresize = () => {
				return (() => {
					window.fullHeight = document.documentElement.clientHeight;
					that.curHeight = window.fullHeight; // 高

				})()
			};
		},
	};
</script>

<style scoped>
	.main-content {
		min-height: 100%;
		min-width: 1400px;
		width: 100%;
		margin: 0 auto;
		display: block;
		position: absolute;
		/* background: #f7f7f7; */
	}

	.prduct-box {
		width: 1200px;
		/* padding-top: 60px; */
		padding-bottom: 100px;
		margin: 0 auto;
	}

	.center-body {
		margin: 0 auto;
	}

	.fixed-bottom {
		position: fixed;
		bottom: 0;
	}
	.hxyx-box{
		height: 793px;
		background-image: url(../../assets/img/gywmbg.png);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		padding-top: 80px;
		text-align: center;
	}
	.mfty-box{
		height: 600px;
		background-color: #fff;
		padding-top: 60px;
		text-align: center;
	}
	.active{
		color: #fff !important;
		background-color: #0070FD !important;
	}

	.apps-wrap {
		max-width: 1200px;
		width: 100%;
		margin-top: 48px;
		padding: 0 24px;
		box-sizing: border-box;
		flex-shrink: 0;
    margin-top: 120px;
	}

	.apps-bar {
		margin-top: 0;
		display: flex;
		align-items: center;
		justify-content: space-evenly;
		flex-wrap: wrap;
		row-gap: 14px;
		column-gap: 16px;
		padding: 18px 22px;
		background: linear-gradient(90deg, #eaf3ff 0%, #ffffff 45%, #f2f7fc 100%);
		border-radius: 8px;
		box-sizing: border-box;
	}

	.apps-item {
		display: flex;
		align-items: center;
		gap: 10px;
		flex-shrink: 0;
	}

	.apps-icon-wrap {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		background: #fff;
		border: 1px solid #d5d5d5;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		box-sizing: border-box;
	}

	.apps-briefcase {
		width: 20px;
		height: 20px;
		color: #111;
		display: block;
	}

	.apps-label {
		font-size: 14px;
		color: #111;
		font-weight: 400;
		white-space: nowrap;
	}

	.sys-card-icon {
		width: 48px;
		height: 48px;
		background: #e1f5ff;
		border-radius: 8px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #409eff;
		flex-shrink: 0;
	}

	.sys-card-icon svg {
		width: 24px;
		height: 24px;
		display: block;
	}

	/* 核心优势 · 产品特点（图标由 productFeatures[].icon 语义驱动） */
	.product {
		padding: 72px 24px 96px;
		background: linear-gradient(180deg, #ffffff 0%, #f3f6ff 42%, #f5f2fc 100%);
		box-sizing: border-box;
	}

	.product-wrap {
		max-width: 1200px;
		margin: 0 auto;
	}

	.product-inner {
		background: linear-gradient(160deg, #ffffff 0%, #faf8ff 55%, #f4f7ff 100%);
		border-radius: 20px;
		padding: 48px 44px 56px;
		border: 1px solid rgba(226, 232, 240, 0.95);
		box-shadow: 0 8px 32px rgba(15, 23, 42, 0.06);
		box-sizing: border-box;
	}

	.product-kicker {
		margin: 0 0 10px;
		text-align: center;
		font-size: 16px;
		font-weight: 500;
		color: #409eff;
		letter-spacing: 0.02em;
	}

	.product-headline {
		margin: 0 0 44px;
		text-align: center;
		font-size: 28px;
		font-weight: 700;
		color: #333;
		line-height: 1.3;
	}

	.product-grid {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 28px 36px;
		align-items: start;
	}

	.product-card {
		text-align: center;
	}

	.product-icon {
		width: 56px;
		height: 56px;
		margin: 0 auto 18px;
		color: #409eff;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.product-icon-svg {
		width: 56px;
		height: 56px;
		display: block;
		flex-shrink: 0;
	}

	.product-card-title {
		margin: 0 0 12px;
		font-size: 18px;
		font-weight: 600;
		color: #333;
		line-height: 1.4;
	}

	.product-card-text {
		margin: 0;
		font-size: 14px;
		line-height: 22px;
		color: #666;
		text-align: left;
	}
</style>
